<template>
  <div class="share-network-container">
    <div class="mr-1 mr-lg-3 mr-xl-3">
      <font-awesome-icon :id="'tooltip-copy-' + _uid" size="1x" icon="link" v-on:click="onCopyLink" />
      <b-tooltip variant="primary" :target="'tooltip-copy-' + _uid">
        {{ linkCopyText }}
      </b-tooltip>
    </div> 
   
    <div class="mr-1 mr-lg-3 mr-xl-3">
      <ShareNetwork network="linkedin" :url="url" :title="title">
        <font-awesome-icon class="pl-1" size="2x" :icon="['fab', 'linkedin']" id="linkedin-icon" />
        <b-tooltip variant="primary" target="linkedin-icon">
          Share on LinkedIn
        </b-tooltip>
      </ShareNetwork>
    </div>
    <div class="mr-1 mr-lg-3 mr-xl-3">
      <ShareNetwork network="twitter" :url="url" :title="title" :description="description">
        <img alt="twitter log" class="x-twtter-logo" src="../assets/images/logo/X_logo_2023_original.svg"
          id="twitter-icon" />
        <b-tooltip variant="primary" target="twitter-icon">
          Share on Twitter
        </b-tooltip>
      </ShareNetwork>
    </div>
    <div class="mr-1 mr-lg-3 mr-xl-3">
      <ShareNetwork network="facebook" :url="url" :title="title" :description="description">
        <font-awesome-icon id="facebook-icon" class="pl-1" size="2x" :icon="['fab', 'facebook-square']" />
        <b-tooltip variant="primary" target="facebook-icon">
          Share on Facebook
        </b-tooltip>
      </ShareNetwork>
    </div>
    <div class="mr-1 mr-lg-3 mr-xl-3">
      <ShareNetwork network="reddit" :url="url" :title="title" :description="description">
        <font-awesome-icon id="reddit-icon" class="pl-1" size="2x" :icon="['fab', 'reddit-square']" />
        <b-tooltip variant="primary" target="reddit-icon">
          Share on Reddit
        </b-tooltip>
      </ShareNetwork>
    </div>

    <!-- Bookmark Page -->

  </div>
</template>
<script>
import axios from 'axios';
import { isLoggedIn, handleApiError } from '../utils/authentication';


export default {
  name: 'social-share',
  props: ['title', 'description', 'type'],
  data() {
    return {
      linkCopyText: 'Click to copy url link',
      isPageBookmarked: false,
    };
  },
  mounted() {
    // TODO: Check is the item is currently bookmarked
    // this.checkIfBookmarked()
  },
  computed: {
    url() {
      return location.href || 'URL';
    },
  },
  methods: {
    onCopyLink() {
      navigator.clipboard.writeText(location.href);
      this.linkCopyText = 'Link Copied!';
    },
  },
};
</script>
<style scoped>
.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}

.x-twtter-logo {
  width: 24px;
  height: 24px;
  position: relative;
  top: -2px;
  right: -2px;
}
</style>
